import { Subfolder } from "../../../redux/interfaces/folder.types.ts";
import { View } from "../../base-requirements/requirements/View.tsx";
import { Notes } from "../Notes.tsx";
import { History } from "../history/History.tsx";
import { AnalysisForm } from "../AnalysisForm.tsx";

export const getFolderExtraInfoTabs = (
  subfolders: Subfolder[],
  hasCollaborator: boolean = false,
) => {
  const arrayFolderExtras = [
    {
      label: "Requisitos",
      key: "1",
      children: (
        <div className="w-full">
          <View subfolders={subfolders} />
        </div>
      ),
    },
    {
      label: hasCollaborator ? "Notas de Ops" : "Notas",
      key: "2",
      children: (
        <div className="w-full">
          <Notes />
        </div>
      ),
    },
    {
      label: "Análisis",
      key: "3",
      children: (
        <div className="w-full">
          <AnalysisForm />
        </div>
      ),
    },
    {
      label: "Historial",
      key: "4",
      children: (
        <div className="w-full">
          <History />
        </div>
      ),
    },
  ];

  if (hasCollaborator) {
    return arrayFolderExtras.toSpliced(2, 0, {
      label: "Notas de CJA",
      key: "5",
      children: (
        <div className="w-full">
          <Notes isCjaNotes={true} />
        </div>
      ),
    });
  }

  return arrayFolderExtras;
};
